import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import {
  selectAuthenticatedUser,
  selectIsAuthenticated,
} from '../+state/auth.selectors';

export const authGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router);

  return store.pipe(selectIsAuthenticated).pipe(
    map((isAuthenticated) => {
      return (
        isAuthenticated ||
        router.createUrlTree(['login'], {
          queryParams: { return_url: state.url },
        })
      );
    }),
  );
};

export const isMasterGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(selectAuthenticatedUser).pipe(
    map((user) => {
      return user?.belongsToMasterGroup || router.createUrlTree(['forbidden']);
    }),
  );
};
